<div style="margin-bottom: 10px;">
  <div class="text-area">
    <input #element type="search" [ngClass]="'input-search ' + size" results [disabled]="disable"
      [placeholder]="placeholder" [(ngModel)]="searchTerm" (focus)="onFocus(true)" (blur)="onFocus(false)">
    <img src="assets/icons/Icon ionic-ios-search.svg" style="margin-right: 5px;">
    <mat-spinner class="spinner" *ngIf="searching()" diameter="20"></mat-spinner>
  </div>
  <div class="scrollbar" [class.results]="itemsToShow().length" id="style-1">
    <table>
      <tbody>
        <tr *ngFor="let item of itemsToShow()" style="cursor: pointer;" class="row" (click)="selectItem(item)">
          <td style="width: 550px;" [innerHTML]="item | boldSubstring : (highlightSearchTerm ? searchTerm() : '')">
            <!-- boldSubstring age como funcao identidade se param for string vazia -->
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
